(function() {
  vtex.define('shipping/script/component/ShippingSummary',['flight/lib/component', 'shipping/script/setup/extensions', 'shipping/script/mixin/withi18n', 'shipping/script/mixin/withLogisticsInfo', 'shipping/script/component/ShippingDataStore', 'shipping/templates/shippingSummary'], function(defineComponent, extensions, withi18n, withLogisticsInfo, ShippingDataStore, template) {
    var ShippingSummary;
    ShippingSummary = function() {
      this.defaultAttrs({
        data: {
          active: false,
          address: {},
          multipleSellers: false
        },
        maskedInfoSelector: '.client-masked-info'
      });
      this.render = function() {
        var _this = this;
        return dust.render(template, this.attr.data, function(err, output) {
          if (!_this.attr.data.active) {
            return;
          }
          output = $(output).i18n();
          return _this.$node.html(output);
        });
      };
      this.enable = function(ev, locale, shippingData, items, sellers, rules, canEditData, giftRegistryData) {
        var _ref, _ref1, _ref2,
          _this = this;
        if (ev != null) {
          ev.stopPropagation();
        }
        this.attr.data.active = true;
        this.setLocale(locale);
        this.attr.data.items = items;
        this.attr.data.sellers = sellers;
        this.attr.data.canEditData = canEditData;
        this.attr.data.postalCodeByInput = rules != null ? rules.postalCodeByInput : void 0;
        this.attr.data.address = this.getFirstAddressWithAddressType(shippingData);
        if (((rules != null ? (_ref = rules.masks) != null ? _ref.postalCode : void 0 : void 0) != null) && (((_ref1 = this.attr.data.address) != null ? _ref1.postalCode : void 0) != null)) {
          this.attr.data.address.postalCode = _.maskString(this.attr.data.address.postalCode, rules.masks.postalCode);
        }
        this.attr.data.isGift = ((_ref2 = this.attr.data.address) != null ? _ref2.addressType : void 0) === "giftRegistry";
        this.attr.data.giftRegistryData = giftRegistryData;
        this.attr.data.logisticsInfo = shippingData.logisticsInfo;
        this.attr.data.isStateUpperCase = rules != null ? rules.isStateUpperCase : void 0;
        this.attr.data.shippingOptions = this.getShippingOptionsData(shippingData.logisticsInfo, items, sellers);
        return this.updateShippingOptionsLabels(this.attr.data.shippingOptions).then(function() {
          if (_this.attr.data.active) {
            return _this.render();
          }
        });
      };
      this.disable = function(ev) {
        this.attr.data.active = false;
        if (ev != null) {
          ev.stopPropagation();
        }
        return this.$node.html('');
      };
      this.addressSelected = function(ev, address) {
        if (ev != null) {
          ev.stopPropagation();
        }
        this.attr.data.address = address;
        if (this.attr.data.active) {
          return this.render();
        }
      };
      this.deliverySelected = function(ev, logisticsInfo, options) {
        var items, sellers,
          _this = this;
        if (ev != null) {
          ev.stopPropagation();
        }
        if (options && options.skipSendAttachment) {
          return;
        }
        this.attr.data.logisticsInfo = logisticsInfo;
        items = this.attr.data.items;
        sellers = this.attr.data.sellers;
        this.attr.data.shippingOptions = this.getShippingOptionsData(logisticsInfo, items, sellers);
        return this.updateShippingOptionsLabels(this.attr.data.shippingOptions).then(function() {
          if (_this.attr.data.active) {
            return _this.render();
          }
        });
      };
      this.showMaskedInfoMessage = function(ev) {
        if (ev != null) {
          ev.preventDefault();
        }
        return $(window).trigger('showMessage.vtex', ['maskedInfo']);
      };
      this.getFirstAddressWithAddressType = function(shippingData) {
        var currentAddress, _ref;
        currentAddress = shippingData.address;
        if (!((_ref = shippingData.address) != null ? _ref.addressType : void 0)) {
          currentAddress = shippingData.availableAddresses.find(function(address) {
            return address.addressType;
          });
          ShippingDataStore.sendAttachment({
            address: currentAddress
          });
        }
        return currentAddress;
      };
      return this.after('initialize', function() {
        this.on('enable.vtex', this.enable);
        this.on('disable.vtex', this.disable);
        this.on('addressSelected.vtex', this.addressSelected);
        this.on('deliverySelected.vtex', this.deliverySelected);
        this.on('click', {
          maskedInfoSelector: this.showMaskedInfoMessage
        });
        return this.setLocalePath('shipping/script/translation/');
      });
    };
    return defineComponent(ShippingSummary, withi18n, withLogisticsInfo);
  });

}).call(this);

